<template>
  <div>
    <div>
      <el-form ref="form">
        <el-space wrap>
          <el-form-item label="板块:">
            <el-select v-model="obj.block" @change="handleSelectChange" style="width:120px" disabled="true">
              <el-option v-for="item in obj.blockList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="期间:">
            <el-select v-model="obj.day" @change="handleSelectChange" style="width:120px" disabled="true">
              <el-option v-for="item in obj.dayList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="信号级别:">
            <el-select v-model="obj.interval" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.intervalList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="信号多空:">
            <el-select v-model="obj.trend" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.trendList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="信号强度:">
            <el-select v-model="obj.level" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.level_List" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="开平仓条件:">
            <el-select v-model="obj.operationLevel" @change="handleSelectChange" style="width:120px">
              <el-option v-for="item in obj.operationLevel_list" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="">
            <el-button type="primary" @click="handleSubmit">
              <el-icon class="el-input__icon">
                <cpu />
              </el-icon>筛选
            </el-button>
          </el-form-item> -->
          <el-form-item label="">
            <el-button type="primary" @click="handleRefresh">
              <el-icon class="el-input__icon">
                <refresh />
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </el-form>
    </div>
    <div>
      <el-tag type="warning" size="small" v-if="obj.date !== ''">更新日： {{ obj.date }}</el-tag>
    </div>
    <div>
      <!-- <el-tag type="warning" size="small">最新信号</el-tag> -->
    </div>
    <div>
      <el-table :data="obj.dataList" height="100%" style="width: 100%;" empty-text=" "
        :style="'height:' + (this.$store.state.windowHeight - 200) / 1 + 'px'" :cell-style="cellStyle"
        @row-click="handleRowClick2" highlight-current-row ref="singleTableRef">
        <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
        <el-table-column fixed label="名称" prop="name" width="140px" align="right" sortable />
        <el-table-column label="代码" prop="symbol" width="100px" align="right" sortable />
        <el-table-column label="收盘" prop="close" width="80px" align="right" />
        <el-table-column label="涨幅%" prop="chgPct" width="100px" align="right" :sort-method="customPctSort" sortable />
        <el-table-column label="板块" prop="industry" width="100px" align="right" sortable />
        <el-table-column label="多头信号" prop="signal_long" width="440px" align="left" />
        <el-table-column label="信号强度" prop="signal_long_lv" width="110px" align="left" sortable />
        <el-table-column label="空头信号" prop="signal_short" width="440px" align="left" />
        <el-table-column label="信号强度" prop="signal_short_lv" width="110px" align="left" sortable />
        <!-- <el-table-column label="开平仓" prop="" width="80px" align="left">
          <template #default="scope">
            <el-button v-if="scope.row.open_close == '1' && scope.row.direction == '1'" size="small" type="danger"
              @click.stop="handleOperation(scope.$index, scope.row)">多开</el-button>
            <el-button v-if="scope.row.open_close == '1' && scope.row.direction == '0'" size="small" type="success"
              @click.stop="handleOperation(scope.$index, scope.row)">空开</el-button>
            <el-button v-if="scope.row.open_close == '0' && scope.row.direction == '1'" size="small" type="primary"
              @click.stop="handleOperation(scope.$index, scope.row)">多平</el-button>
            <el-button v-if="scope.row.open_close == '0' && scope.row.direction == '0'" size="small" type="primary"
              @click.stop="handleOperation(scope.$index, scope.row)">空平</el-button>
            <span v-if="scope.row.holding == '1'">持仓中</span>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div>
      <!-- <el-tag type="warning" size="small">信号详细</el-tag> -->
    </div>
    <!-- <div>
      <el-table :data="obj.dataList2" height="100%" style="width: 100%" empty-text=" "
        :style="'height:' + (this.$store.state.windowHeight - 200) / 2 + 'px'" :cell-style="cellStyle2"
        @row-click="handleRowClick2" highlight-current-row ref="singleTableRef">
        <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
        <el-table-column fixed label="日期" prop="date" width="110px" align="right" />
        <el-table-column fixed label="名称" prop="name" width="110px" align="right" />
        <el-table-column label="代码" prop="symbol" width="100px" align="right" />
        <el-table-column label="收盘" prop="close" width="80px" align="right" />
        <el-table-column label="涨幅%" prop="chgPct" width="100px" align="right" />
        <el-table-column label="上穿MA5(日)" prop="MA5_CROSSUP" width="110px" align="right" />
        <el-table-column label="大阳(日)" prop="BIG_UP" width="100px" align="right" />
        <el-table-column label="底背离(日)" prop="short_divergence" width="100px" align="right" />
        <el-table-column label="上穿MA5(周)" prop="W_MA5_CROSSUP" width="110px" align="right" />
        <el-table-column label="板块上穿MA5(日)" prop="I_MA5_CROSSUP" width="140px" align="right" />
        <el-table-column label="下穿MA5(日)" prop="MA5_CROSSDOWN" width="110px" align="right" />
        <el-table-column label="大阴(日)" prop="BIG_DOWN" width="100px" align="right" />
        <el-table-column label="顶背离(日)" prop="long_divergence" width="100px" align="right" />
        <el-table-column label="下穿MA5(周)" prop="W_MA5_CROSSDOWN" width="110px" align="right" />
        <el-table-column label="板块下穿MA5(日)" prop="I_MA5_CROSSDOWN" width="140px" align="right" />
        <el-table-column label="开平仓信号" prop="operation" width="100px" align="right" />
        <el-table-column label="平仓收益" prop="profit" width="100px" align="right" />
      </el-table>
    </div> -->
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { http } from '../util/http'
import { ElMessage } from 'element-plus'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const singleTableRef = ref()
    const chartDomRef = ref()
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      blockList: [
        {
          value: '',
          label: '全部'
        }
      ],
      block: '',
      dayList: [
        {
          value: '1',
          label: '最近1日'
        },
        {
          value: '2',
          label: '最近2日'
        },
        {
          value: '3',
          label: '最近3日'
        },
        {
          value: '4',
          label: '最近4日'
        },
        {
          value: '5',
          label: '最近5日'
        },
      ],
      day: '1',
      intervalList: [
        {
          value: '1',
          label: '日线'
        },
        {
          value: '2',
          label: '1小时线'
        },
        {
          value: '3',
          label: '15分钟线'
        },
      ],
      interval: '1',
      trendList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'Long',
          label: '多头'
        },
        {
          value: 'Short',
          label: '空头'
        },
      ],
      trend: '',
      level_List: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '1级'
        },
        {
          value: '2',
          label: '2级'
        },
        {
          value: '3',
          label: '3级'
        },
        {
          value: '4',
          label: '4级'
        },
        {
          value: '5',
          label: '5级'
        },
        {
          value: '6',
          label: '6级'
        },
      ],
      level: '',
      operationLevel_list: [
        {
          value: '3',
          label: '3级以上'
        },
        {
          value: '4',
          label: '4级以上'
        },
        {
          value: '5',
          label: '5级以上'
        },
      ],
      operationLevel: '5',
      dataList: [],
      dataList2: [],
      date: '',
      selectedBlock: '',
      selectedBlockValue: '',
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      setStore()
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.signalData === '') {
        // 无缓存，从后台请求数据
        requestData()
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 后台获取数据
    const requestData = () => {
      let formData = new FormData()
      formData.append("day", obj.day)
      formData.append("interval", obj.interval)
      formData.append("trend", obj.trend)
      formData.append("level", obj.level)
      formData.append("operationLevel", obj.operationLevel)
      http({
        url: `/signal`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        if (res.data.data.length === 0) {
          ElMessage.info('没有符合条件的数据')
        }
        obj.dataList = processData(res.data.data)
        setStore()

        // 如果选择的合约在重新刷新后的最新信号一览(obj.dataList)内才执行requestData2
        if (obj.selectedBlock != "") {
          let flag = false
          for (let x of obj.dataList) {
            if (x.name === obj.selectedBlock) {
              flag = true
              break
            }
          }
          if (flag) {
            requestData2(obj.selectedBlock)
          } else {
            obj.dataList2 = []
            obj.selectedBlock = ""
            obj.selectedBlockValue = ""
          }

        }
      })
    }

    // 后台获取数据2
    const requestData2 = (name) => {
      let formData = new FormData()
      formData.append("name", name)
      formData.append("day", obj.day)
      formData.append("operationLevel", obj.operationLevel)
      http({
        url: `/signal`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        if (res.data.data.length === 0) {
          ElMessage.info('没有符合条件的数据')
        }
        obj.dataList2 = processData2(res.data.data)
        setStore()
      })
    }

    // const setCurrent = (row) => {
    //   singleTableRef.value.setCurrentRow(row)
    // }

    // 处理数据
    const processData = (data) => {
      let no = 1
      data.forEach((item) => {
        obj.date = item.date
        if (item.chgPct !== "-") {
          item.chgPct = parseFloat(item.chgPct * 100).toFixed(2) + '%'
        }
        item.no = no
        no++

        // item.name = item.name + ' ' +item.symbol
      })
      return data
    }

    // 处理数据
    const processData2 = (data) => {
      let no = 1
      data.forEach((item) => {
        if (item.chgPct !== "-") {
          item.chgPct = parseFloat(item.chgPct * 100).toFixed(2) + '%'
        }
        if (item.profit != "-") {
          item.profit = parseFloat(item.profit * 100).toFixed(2) + '%'
        }
        item.no = no
        no++
      })
      return data
    }

    // 保存Store
    const setStore = () => {
      var storeObj = {
        'block': obj.block,
        'day': obj.day,
        'interval': obj.interval,
        'trend': obj.trend,
        'level': obj.level,
        'operationLevel': obj.operationLevel,
        'dataList': obj.dataList,
        'dataList2': obj.dataList2,
        'date': obj.date,
        'selectedBlock': obj.selectedBlock,
        'selectedBlockValue': obj.selectedBlockValue
      }
      store.commit('setSignalData', storeObj)
    }

    // 获取Store
    const getStore = () => {
      obj.block = store.state.signalData.block
      obj.day = store.state.signalData.day
      obj.interval = store.state.signalData.interval
      obj.trend = store.state.signalData.trend
      obj.level = store.state.signalData.level
      obj.operationLevel = store.state.signalData.operationLevel
      obj.date = store.state.signalData.date
      obj.dataList = store.state.signalData.dataList
      obj.dataList2 = store.state.signalData.dataList2
      obj.selectedBlock = store.state.signalData.selectedBlock
      obj.selectedBlockValue = store.state.signalData.selectedBlockValue
    }

    // 重置画面
    const resetView = () => {
      obj.block = ''
      obj.day = 3
      obj.interval = ''
      obj.trend = ''
      obj.level = ''
      obj.operationLevel = ''
      obj.date = ''
      obj.dataList = []
      obj.dataList = ''
      obj.dataList2 = []
      obj.dataList2 = ''
      obj.selectedBlock = ''
      obj.selectedBlockValue = ''
    }

    /**
     * 事件处理区域
     */

    // 下拉框选择事件
    const handleSelectChange = (e) => {
      // obj.total = 0
      // obj.page = 1
      requestData()
    }

    // 按钮刷新事件
    const handleRefresh = (e) => {
      // obj.total = 0
      // obj.page = 1
      requestData()
    }

    // 表格行点击事件
    const handleRowClick = (row) => {
      obj.selectedBlock = row.name
      obj.selectedBlockValue = row.symbol
      requestData2(obj.selectedBlock)
    }

    // 表格行点击事件2
    const handleRowClick2 = (row) => {
      let name = row.name
      store.commit('setCurrentContract', name)
      router.push(`/candlestick?name=${name}`)
    }

    // 按钮提交事件
    const handleSubmit = () => {
      // if (!formCheck()) {
      //   return
      // }
      obj.selectedBlock = ""
      obj.selectedBlockValue = ""
      requestData()
    }

    // 表单Check处理
    const formCheck = () => {
      if (obj.indicators.trim() === '' && obj.patterns.trim() === '' &&
        (obj.customize.trim() === '' || obj.symbols.trim() === '')) {
        ElMessage.error('请选择或输入条件')
        return false
      }
      return true
    }

    // 开平仓
    const handleOperation = (index, row) => {
      // console.log(index, row)
      let formData = new FormData()
      formData.append("name", row.name)
      formData.append("open_close", row.open_close)
      formData.append("direction", row.direction)
      formData.append("quantity", row.quantity)
      formData.append("price", row.close)
      http({
        url: `/trade`,
        method: 'post',
        data: formData
      }).then((res) => {
        ElMessage.success('操作成功')
        row.open_close = -1
        row.direction = -1
        row.quantity = -1
        // vueEvent.emit('updateBalanceEvent')
      })
    }

    /**
     * 样式设置区域
     */

    // 表格单元格样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      if (row.row.chgPct.toString().replace('%', '') > 0 && row.columnIndex === 4) {
        return { color: 'red' }
      } else if (row.row.chgPct.toString().replace('%', '') < 0 && row.columnIndex === 4) {
        return { color: 'green' }
      }

      if (row.row.signal_long.toString() != "" && row.columnIndex === 6) {
        return { color: 'red' }
      }
      if (row.row.signal_long_lv.toString() != 0 && row.columnIndex === 7) {
        return { color: 'red' }
      }
      if (row.row.signal_short.toString() != "" && row.columnIndex === 8) {
        return { color: 'green' }
      }
      if (row.row.signal_short_lv.toString() != 0 && row.columnIndex === 9) {
        return { color: 'green' }
      }
    }

    // 表格单元格样式2
    const cellStyle2 = (row, column, rowIndex, columnIndex) => {
      if (row.row.chgPct.toString().replace('%', '') > 0 && row.columnIndex === 5) {
        return { color: 'red' }
      } else if (row.row.chgPct.toString().replace('%', '') < 0 && row.columnIndex === 5) {
        return { color: 'green' }
      }

      if (row.row.MA5_CROSSUP == 1 && row.columnIndex === 6) {
        return { color: 'red' }
      }
      if (row.row.BIG_UP == 1 && row.columnIndex === 7) {
        return { color: 'red' }
      }
      if (row.row.short_divergence == 1 && row.columnIndex === 8) {
        return { color: 'red' }
      }
      if (row.row.W_MA5_CROSSUP == 1 && row.columnIndex === 9) {
        return { color: 'red' }
      }
      if (row.row.I_MA5_CROSSUP == 1 && row.columnIndex === 10) {
        return { color: 'red' }
      }

      if (row.row.MA5_CROSSDOWN == 1 && row.columnIndex === 11) {
        return { color: 'green' }
      }
      if (row.row.BIG_DOWN == 1 && row.columnIndex === 12) {
        return { color: 'green' }
      }
      if (row.row.long_divergence == 1 && row.columnIndex === 13) {
        return { color: 'green' }
      }
      if (row.row.W_MA5_CROSSDOWN == 1 && row.columnIndex === 14) {
        return { color: 'green' }
      }
      if (row.row.I_MA5_CROSSDOWN == 1 && row.columnIndex === 15) {
        return { color: 'green' }
      }

      if ((row.row.operation == "多开" || row.row.operation == "空平") && row.columnIndex === 16) {
        return { color: 'red' }
      } else if ((row.row.operation == "空开" || row.row.operation == "多平") && row.columnIndex === 16) {
        return { color: 'green' }
      }
    }


    // 表格排序(带百分号的数字列)
    const customPctSort = (a, b) => {
      return parseFloat(a.chgPct.replace('%', '')) - parseFloat(b.chgPct.replace('%', ''))
    }

    return {
      obj,
      chartDomRef,
      store,
      handleSelectChange,
      handleRefresh,
      handleRowClick,
      handleRowClick2,
      handleSubmit,
      handleOperation,
      cellStyle,
      cellStyle2,
      customPctSort,
    }
  }
}
</script>
<style lang="scss" scoped></style>
